export default __webpack_public_path__ + "static/media/events-icon.b35fee22.png";